import React, { useEffect, useState } from "react";
import {
  X,
  Bell,
  Info,
  CheckCircle2,
  AlertCircle,
  CircleX,
} from "lucide-react";
import { apiGet } from "../../Services/Services";
import { ENDPOINTS } from "../../Services/Endpoints";
import "./NotificationModal.css";

const iconByType = {
  success: CheckCircle2,
  alert: AlertCircle,
  info: Info,
  error: CircleX,
};

function NotificationModal({ open, onClose }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAllNotifications = async () => {
    try {
      setLoading(true);

      const response = await apiGet(
        ENDPOINTS.notifications.viewAll,
        {},
        {},
        {
          showSuccessToast: false,
          useApiSuccessMessage: false,
        },
      );

      setNotifications(response?.data ?? []);
      console.log("ALL NOTIFICATION", response?.data ?? []);
    } catch (error) {
      console.log("ALL NOTIFICATION ERROR", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchAllNotifications();
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="notification-modal-overlay" onClick={onClose}>
      <div className="notification-modal" onClick={(e) => e.stopPropagation()}>
        <div className="notification-modal-header">
          <div>
            <Bell size={20} />
            <h2>All Notifications</h2>
          </div>

          <button onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="notification-modal-body">
          {loading && <p>Loading...</p>}

          {!loading &&
            notifications.map((item) => {
              const Icon = iconByType[item.type] || Info;

              return (
                <div className="all-notification-card" key={item.id}>
                  {/* <div className={`notification-icon ${item.type}`}>
                    <Icon size={18} />
                  </div> */}

                  <div>
                    <h4>{item.type}</h4>

                    <p>{item.message}</p>

                    <small>{item.time}</small>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default NotificationModal;
